import { API_URL_WEBINAR } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditWebinar from "types/Webinar/createEditWebinar";

const updateWebinar = (uuid: string, editedItem: TCreateEditWebinar) =>
  apiInstance({
    url: API_URL_WEBINAR + uuid,
    method: "put",
    data: editedItem,
  });

export default updateWebinar;
